import { WintUtilsWebApi } from "wint-api-client/dist/types";
import { AxiosResponse } from "axios";

const ServiceHelper = {
  getAllPages: async <T>(
    apiFunc: (pageNumber: number) => Promise<AxiosResponse<WintUtilsWebApi.ListResponse<T>>>
  ): Promise<T[]> => {
    let page = 0;
    let items: T[] = [];
    let total = 0;
    await apiFunc(page).then((response) => {
      total = response.data?.totalItems;
      items = response.data?.items ? response.data.items : [];
    });

    while (total > items.length) {
      page = ++page;
      const response = await apiFunc(page);
      items = items.concat(response.data.items ? response.data.items : []);
    }

    return items;
  },

  withAPIRequestKey: <T>(response: Promise<T>, apiKey?: any) =>
    response.then((result) => ({ data: result, key: apiKey })),
};

export default ServiceHelper;
